import {
  fetchBranches,
  fetchCountries,
  fetchMosques,
  fetchQuranSectionLines,
  fetchQuranSections
} from '@/services/app'
import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef, Ref } from 'vue'

export const useCountries = () =>
  useQuery({
    queryKey: ['countries'],
    queryFn: fetchCountries
  })

export const useBranches = () =>
  useQuery({
    queryKey: ['branches'],
    queryFn: fetchBranches
  })

export const useMosques = (branchId: ComputedRef<number> | Ref<number>) =>
  useQuery({
    queryKey: ['mosques', branchId],
    queryFn: () => fetchMosques(branchId.value)
  })

export const useQuranSections = (branchId: ComputedRef<number> | Ref<number>) =>
  useQuery({
    queryKey: ['quran_sections', branchId],
    queryFn: () => fetchQuranSections(branchId.value)
  })

export const useQuranSectionLines = (sectionId: ComputedRef<number> | Ref<number>) =>
  useQuery({
    queryKey: ['quran_section_lines', sectionId],
    queryFn: () => fetchQuranSectionLines(sectionId.value)
  })
